export default __webpack_public_path__ + "static/media/search.6dca982e.svg";